const AboutSection = () => {
  return (
    <section className="bg-background py-4 sm:py-6 lg:py-8">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="font-heading text-2xl md:text-4xl tracking-wider text-foreground mb-8">
          A LUXURY MALARIA-FREE GAME LODGE IN THE LIMPOPO BUSHVELD
        </h2>
        <div className="space-y-4 text-sm text-muted-foreground leading-relaxed font-body">
          <p>
            Zwahili is a privately owned luxury game lodge and spa set in a
            malaria-free region of the Limpopo bushveld, a two-hour
            drive north of Johannesburg — an oasis of tranquillity in the
            African bush for no more than 20 guests at a time.
          </p>
          <p>
            The story of this lodge begins with the beginning of time… A time so
            rich with promises and new life.
          </p>
          <p>
            It is now time to share in earth's secret passions and wildlife's raw
            existence.
          </p>
          <p>Time to set foot on Zwahili..</p>
          <p className="font-body font-medium mt-6 mb-0 text-accent text-sm">
            Kuwakaribisha kwa joto!
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
